import type { ProLayoutProps } from '@ant-design/pro-components';
import { withPublicPath } from './appPath';

const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#3fbddd',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: false,
  pwa: false,
  logo: 'https://public-1253450979.file.myqcloud.com/benhealth.png',
  iconfontUrl: '',
  token: {},
};

export default Settings;
